module.exports = __webpack_public_path__ + "img/FaBe_JH_002.2d28fbc5.jpg";